"use client";

import { usePathname } from "next/navigation";
import ScrollToTop from "@/components/ui/ScrollToTop";
import ChatBotWrapper from "@/components/ui/ChatBotWrapper";

export default function FloatingWidgets() {
  const path = usePathname();
  if (path.startsWith("/auth")) return null;
  return (
    <>
      <ScrollToTop />
      <ChatBotWrapper />
    </>
  );
}
